export function Dashboard() {
  return (
    <div className="p-8 max-w-7xl mx-auto">
      <h1 className="font-display text-3xl font-bold text-text mb-2">Welcome to envelo</h1>
      <p className="text-text-muted mb-8">Your private collaboration suite.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card title="Mail" description="Encrypted email with JMAP" to="/mail" />
        <Card title="Calendar" description="Schedule with privacy" to="/calendar" />
        <Card title="Contacts" description="Your address book" to="/contacts" />
        <Card title="Files" description="Encrypted file storage" to="/files" />
        <Card title="Whiteboard" description="Visual collaboration" to="/whiteboard" />
        <Card title="Chat" description="E2EE team messaging" to="/chat" />
      </div>
    </div>
  )
}

function Card({ title, description, to }: {
  title: string
  description: string
  to: string
}) {
  return (
    <a
      href={to}
      className="block p-6 bg-surface rounded-xl border border-slate-200 hover:shadow-lg hover:border-sovereign-300 transition-all duration-200"
    >
      <h3 className="font-ui text-lg font-semibold text-text mb-1">{title}</h3>
      <p className="text-sm text-text-muted">{description}</p>
    </a>
  )
}
